import { render, staticRenderFns } from "./GlobalChat.vue?vue&type=template&id=83faff36"
import script from "./GlobalChat.vue?vue&type=script&lang=ts"
export * from "./GlobalChat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports